var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgRecommended = function SvgRecommended(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#665CD1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.703 14.898l.867-3.751-2.91-2.523 3.845-.334L10 4.752l1.495 3.538 3.845.334-2.91 2.523.867 3.75L10 12.91l-3.297 1.989z",
    fill: "#fff"
  })));
};
export default SvgRecommended;